/* eslint-disable camelcase */
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateStatusMetaEvent } from 'services/api/marketing-api'

function useMetaEventsStatusUpdate() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['update-status-meta-event'],
    mutationFn: ({ meta_event_id, is_active }) => updateStatusMetaEvent({ meta_event_id, is_active }),
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey: ['get-events-list'] })
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['get-events-list'] })
    },
  })
}

export default useMetaEventsStatusUpdate
